import { useEffect, useState } from 'react';
import axios from 'axios';
import { baseAPI } from '../../config';

/**
 * La lista de clientes, que varias pantallas de configuración necesitan para
 * poner un nombre donde sólo hay un id.
 *
 * Falla en silencio a propósito: es información de apoyo, no el contenido de la
 * pantalla. Si no carga, se enseña el id —feo pero cierto— en vez de tumbar el
 * panel entero.
 *
 * `roles` por defecto es `'company'` porque así nació —lo usan las pantallas de
 * Kapso, que son de AR—, pero el endpoint acepta varios separados por coma. El
 * despachador pide `'client,company'`: un expediente de recobro cuelga de un
 * `client` y uno de AR de una `company`, y para pausar hace falta poder elegir
 * cualquiera de los dos.
 */
export function useCompanies(roles = 'company') {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .get(`${baseAPI}/users/list?role=${encodeURIComponent(roles)}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then(res => setCompanies(res.data || []))
      .catch(() => setCompanies([]));
  }, [roles]);

  return companies;
}

export const nombreDeEmpresa = (companies, id) => {
  const c = companies.find(x => x._id === id);
  if (!c) return id;
  return `${c.username || ''} ${c.userlastname || ''}`.trim() || c.usermail || id;
};
